import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import ApplicationContext from '../../../context/ApplicationContext'
import styles from '../Footer.module.scss'
import Badge from '../../Badge/Badge'
import { ReactComponent as TruckIcon } from '../../../assets/media/icons/truck.svg'
import { ReactComponent as MrPing } from '../../../assets/media/icons/icon-mr-ping.svg'
import { ReactComponent as RibbonIcon } from '../../../assets/media/icons/ribbon.svg'
import { ReactComponent as FittorOfTheYearIcon } from '../../../assets/media/icons/icon-star-white.svg'
import { ReactComponent as PLDFitterIcon } from '../../../assets/media/icons/pld-fitter-badge.svg'

const badgeIcons = {
    power: <FittorOfTheYearIcon />,
    ribbon: <RibbonIcon />,
    truck: <TruckIcon />,
    logo: <MrPing />,
    pld: <PLDFitterIcon />,
}

const FittersLegendItem = ({ title, paragraphs, links }) => {
    const [applicationData] = useContext(ApplicationContext)

    return (
        <>
            <h5 className={styles.fitterLegend_title}>{title}</h5>
            {paragraphs.map((paragraph, i) => (
                <p key={i} className={styles.fitterLegend_text}>
                    {paragraph}
                </p>
            ))}
            {links &&
                links
                    .filter(link => !link?.key || applicationData[link.key] !== 'hide')
                    .map((link, i) => (
                        <a
                            key={i}
                            href={link?.key && applicationData[link.key] !== '' ? applicationData[link.key] : link?.href}
                            target={`${link.target ?? '_blank'}`}
                            rel='noreferrer nofollow'
                            className={styles.externalLink}
                        >
                            {link?.text}
                        </a>
                    ))}
        </>
    )
}

const FittersLegend = () => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)
    const { fittingExperience } = localizations.footer

    return (
        <div className={styles.footerContainer_rightBox}>
            <div className={styles.fitterLegend}>
                {fittingExperience.legends.map((item, index) => (
                    <div key={index} className={styles.fitterLegend_item}>
                        <div>
                            <Badge color={item.badgeColor} Icon={badgeIcons[item.badgeIcon]} />
                        </div>
                        <FittersLegendItem title={item.title} paragraphs={item.paragraphs} links={item.links} />
                    </div>
                ))}
            </div>
        </div>
    )
}

FittersLegendItem.propTypes = {
    title: PropTypes.string,
    paragraphs: PropTypes.array,
    links: PropTypes.array,
}

export default FittersLegend
